// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"unhighlighted-badge_shadow__53x0T","badge":"unhighlighted-badge_badge__1cdOa"};